// extracted by mini-css-extract-plugin
export default {"container":"comingSoon_container__oGIwW","icon":"comingSoon_icon__bfcpW"};